const Stores = {
  init() {
    this.bindSortChange();
    this.bindUploadLogo();
    this.bindUploadCover();
  },

  bindSortChange() {
    $(document).on("change", ".stores-filter-sort", function () {
      const form = $(this).closest("form");

      if (form.length) {
        form.trigger("submit");
      }
    });
  },

  bindUploadLogo() {
    $(document).on("change", '[data-bb-toggle="change-store-logo"]', (e) => {
      const currentTarget = $(e.currentTarget);
      const url = currentTarget.data("url");
      const file = currentTarget[0].files[0];

      if (!url || !file) return;

      const formData = new FormData();
      formData.append("avatar_file", file);

      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: () => {
          // Optional: show loading
        },
        success: ({ data, message, error }) => {
          if (error) {
            if (typeof Theme !== "undefined") Theme.showError(message);
            return;
          }

          if (typeof Theme !== "undefined") Theme.showSuccess(message);

          $('[data-bb-value="store-logo"]').prop("src", data.url);
        },
        error: (error) => {
          if (typeof Theme !== "undefined") Theme.showError(error.statusText);
        },
      });
    });
  },

  bindUploadCover() {
    $(document).on("change", '[data-bb-toggle="change-store-cover"]', (e) => {
      const currentTarget = $(e.currentTarget);
      const url = currentTarget.data("url");
      const file = currentTarget[0].files[0];

      if (!url || !file) return;

      const formData = new FormData();
      formData.append("cover_file", file);

      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: () => {
          // Optional: show loading
        },
        success: ({ data, message, error }) => {
          if (error) {
            if (typeof Theme !== "undefined") Theme.showError(message);
            return;
          }

          if (typeof Theme !== "undefined") Theme.showSuccess(message);

          const $cover = $('[data-bb-value="store-cover-image"]');
          if ($cover.length) {
            $cover.prop("src", data.url);
          } else {
            const $placeholder = $('[data-bb-value="store-cover-image-placeholder"]');
            if ($placeholder.length) {
              $placeholder.after(`<img src="${data.url}" alt="Cover Image" class="w-100 h-100 object-fit-cover" data-bb-value="store-cover-image">`);
              $placeholder.remove();
            }
          }
        },
        error: (error) => {
          if (typeof Theme !== "undefined") Theme.showError(error.statusText);
        },
      });
    });
  },
};

$(document).ready(() => Stores.init());
